import { Navigate, Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LoadingScreen from "./components/LoadingScreen";
import LinearProgressBar from "./components/Forms/LinearProgressBar";

function ProtectedRoute() {
  const { isAuthenticated, user, isLoading } = useAuth0();

  if (isLoading) return <LinearProgressBar />;
  if (!isAuthenticated) return <Navigate to="/login" />;

  return <Outlet />;
}

export default ProtectedRoute;
